/*
  Enum for Mapping Culture to corresponding Language
  this is needed to not intrude with the URLs
 */
export enum EnglishLanguage {
  ENGLISH = 'en',
}
export enum CultureLanguageMap {
  'en-nl' = 'en_NL',
  'nl-nl' = 'nl_NL',
  'nl-be' = 'nl_BE',
  'fr-be' = 'fr_BE',
  'en-be' = 'en_BE',
  'fr-lu' = 'fr_LU',
  'en-lu' = 'en_LU',
  'de-lu' = 'de_LU',
  'de-de' = 'de',
  'en-de' = 'en_DE',
  'de-at' = 'de_AT',
  'en-at' = 'en_AT',
  'de-ch' = 'de_CH',
  'fr-ch' = 'fr_CH',
  'it-ch' = 'it_CH',
  'en-ch' = 'en_CH',
  'it-it' = 'it',
  'en-it' = 'en_IT',
  'pl-pl' = 'pl',
  'en-pl' = 'en_PL',
  'cs-cz' = 'cs',
  'en-cz' = 'en_CZ',
  'sk-sk' = 'sk',
  'en-sk' = 'en_SK',
  'en-gb' = 'en_GB',
  'hu-hu' = 'hu',
  'en-hu' = 'en_HU',
  'hr-hr' = 'hr',
  'en-hr' = 'en_HR',
  'sl-si' = 'sl',
  'en-si' = 'en_SI',
}

export const AVAILABLE_CULTURES = Object.keys(CultureLanguageMap);
